import React from 'react'
import Comprehensive_Service from './comprehensive_service/Comprehensive_Service'
import Banner from './banner/Banner'
import Pm_Parivar from './pm_parivar/Pm_Parivar'
import Our_Pillars from './our_pillars/Our_Pillars'
import Vision_Mission from './vision_mission/Vision_Mission'
import Sabka_Vikas_Banner from './sabka_vikas_banner/Sabka_Vikas_Banner'
import Road_Parivar_Banner from './road_parivar_banner/Road_Parivar_Banner'




const About_Us = () => {
    return (
        <section className='about-section'>
            <Banner />
            <Comprehensive_Service />
            <Sabka_Vikas_Banner/>

            <Road_Parivar_Banner fullscreen={false}/>
    
            <Pm_Parivar />
            {/* <Our_Pillars/> */}
            <Vision_Mission/>
          
        </section>
    )
}

export default About_Us